import { Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";

export function Quonkle() {
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        display="grid"
        sx={{ gridTemplateColumns: { md: "1fr 1fr 1fr 1fr 1fr" } }}
      >
        <img
          src="/decklists/CustomPrecons/Quonkle/Quonkle, Reverter of Time.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Abjurate.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Accumulation Pile.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Admonisher of Throbe.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Angel of the Nigh Hour.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Back-up Systems.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Being From After.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Bringer of Inspiration.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Clockspinner.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Confulgion.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Creeping Leech.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Curious Familiar.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Desperate Reminiscer.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Digsite Researcher.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Disgruntled Arbiter.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Drain Ego.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Dwell on the Past.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Endless Spiral of Fate.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Enrich.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Exhausted Hero.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Fade From Relevance.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Font of Truth.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Future Flitterers.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Great Octopus of Yore.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Growing Burden.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Herald of Profits.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Impetuous Notetaker.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Intense Study.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Intrigue.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Invert.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Jubilant Investors.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Late Research.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Misenchant.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Mitoser.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Octopus Obfuscator.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Pigeon Hoarder.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Pulled Through the Void.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Quonkle, Once Again.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Quonkles Charm.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Quonkles Hedron.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Quonkles Sentinel.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Refreshing Journey.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Remove Soul.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Reset.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Secret Auditor.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Secret Informant.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Seek Funding.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Slug From Beyond.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Splendiforate.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Stone of Times Past.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/That Which Will Be.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Thoughtful Penser.png"
          width="100%"
        ></img>

        <img
          src="/decklists/CustomPrecons/Quonkle/Throben Researcher.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Trap Thought.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Weary Elder.png"
          width="100%"
        ></img>
        <img
          src="/decklists/CustomPrecons/Quonkle/Wisdom of Age.png"
          width="100%"
        ></img>
      </Grid>
    </Grid>
  );
}
